
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class APIKeysGrid extends Serenity.EntityGrid<APIKeysRow, any> {
        protected getColumnsKey() { return 'Administration.APIKeys'; }
        protected getDialogType() { return APIKeysDialog; }
        protected getIdProperty() { return APIKeysRow.idProperty; }
        protected getInsertPermission() { return APIKeysRow.insertPermission; }
        protected getLocalTextPrefix() { return APIKeysRow.localTextPrefix; }
        protected getService() { return APIKeysService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}